import { createFileRoute, redirect } from '@tanstack/react-router';

/** The old address of the queue; it moved to /approvals. Keeps ?view= and ?open=. */
export const Route = createFileRoute('/_app/changes/')({
  beforeLoad: ({ location }) => {
    throw redirect({
      to: '/approvals',
      search: location.search as never,
      replace: true,
    });
  },
});
